import { Vue, Component, Prop } from 'vue-property-decorator';
import { IModalComponent, Btn, Field, TextField, FormButtonDisabler } from '@samc/centricity-core';
import { IServicerLoanIdOverride } from '@/Interfaces';

@Component({
  name: 'servicer-loan-id-override-modal',
  components: { TextField, Btn, Field, FormButtonDisabler }
})
export default class ServicerLoanIdOverrideModal extends Vue implements IModalComponent {
  @Prop({ required: true }) public loanId!: number;
  @Prop() public addCloseProp!: (callback: () => Promise<IServicerLoanIdOverride | undefined>) => void;
  @Prop() public closeProp!: () => void;

  public oldServicerLoanId: string = '';
  public newServicerLoanId: string = '';

  public mounted() {
    this.addCloseProp(async () => {
      const trimmedOldId = this.oldServicerLoanId?.trim() || '';
      const trimmedNewId = this.newServicerLoanId?.trim() || '';

      const errors: string[] = [];

      if (!trimmedOldId) {
        errors.push('Old Servicer Loan ID cannot be empty.');
      }

      if (!trimmedNewId) {
        errors.push('New Servicer Loan ID cannot be empty.');
      }

      if (errors.length > 0) {
        this.$alert({
          title: 'Validation Error',
          description: 'Please correct the following errors:',
          type: 'error',
          errors: errors
        });
        return undefined;
      }

      return {
        loanId: this.loanId,
        oldServicerLoanId: trimmedOldId,
        newServicerLoanId: trimmedNewId
      } as IServicerLoanIdOverride;
    });
  }
}

